import type { HistoryItem } from "../../types";
import { formatDateShort } from "../../utils/format";
import { IcoCheck, IcoChevronRight } from "../icons";

export function HistoryList({ items }: { items: HistoryItem[] }) {
  return (
    <div class="flex flex-col gap-1">
      {items.map((item) => (
        <HistoryRow key={item.id} item={item} />
      ))}
    </div>
  );
}

export function HistoryRow({ item }: { item: HistoryItem }) {
  return (
    <a
      href={`/orgs/${item.orgId}/forms/${item.formId}?submission=${item.id}`}
      class="group flex items-center gap-3 px-3 py-2.5 -mx-1 rounded-lg hover:bg-surface-hover transition-colors duration-150"
    >
      <div class="size-8 rounded-full flex items-center justify-center bg-green-100/80 dark:bg-green-900/30 flex-shrink-0">
        <IcoCheck class="size-4 text-green-600 dark:text-green-400" />
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-medium text-text truncate leading-snug">
          {item.formTitle || "Untitled form"}
        </p>
        <p class="text-xs text-text-muted mt-0.5">
          {formatDateShort(item.submittedAt)}
        </p>
      </div>
      <IcoChevronRight class="size-4 text-text-subtle opacity-0 group-hover:opacity-100 transition-opacity duration-150" />
    </a>
  );
}
